/**
 * Per-module plan flags for SaaS beauty products.
 */
const FULL_ACCESS_PLANS = new Set(['growth', 'pro']);

export const STANDARD_MAKEUP_CATEGORIES = [
  'lipstick',
  'foundation',
  'blush',
  'eyeshadow',
  'eyeliner',
];

export function normalizeOrgPlan(value) {
  if (value == null || value === '') return 'standard';
  const plan = String(value).toLowerCase().trim();
  if (plan === 'basic') return 'standard';
  if (plan === 'standard' || plan === 'growth' || plan === 'pro') return plan;
  return 'standard';
}

export function getMakeupPlanFlags(plan) {
  const normalized = normalizeOrgPlan(plan);
  const isFullAccess = FULL_ACCESS_PLANS.has(normalized);
  return {
    plan: normalized,
    isFullAccess,
    allowAllMakeup: isFullAccess,
    allowedMakeupCategoryIds: isFullAccess
      ? null
      : new Set(STANDARD_MAKEUP_CATEGORIES),
  };
}

export function getHairColoringPlanFlags(plan) {
  const normalized = normalizeOrgPlan(plan);
  const isFullAccess = FULL_ACCESS_PLANS.has(normalized);
  return {
    plan: normalized,
    isFullAccess,
    allowHairStroke: isFullAccess,
    allowHairGradient: isFullAccess,
    allowHairLayersTab: isFullAccess,
  };
}

export function getHairCutPlanFlags(plan) {
  const normalized = normalizeOrgPlan(plan);
  return {
    plan: normalized,
    isFullAccess: FULL_ACCESS_PLANS.has(normalized),
    allowHairCutTemplates: true,
    allowHairCutPrompt: FULL_ACCESS_PLANS.has(normalized),
  };
}

/** Combined flags for Studio (backward compatible with getMakeupHairPlanFlags). */
export function getMakeupHairPlanFlags(plan) {
  const makeup = getMakeupPlanFlags(plan);
  const coloring = getHairColoringPlanFlags(plan);
  const cut = getHairCutPlanFlags(plan);
  return {
    ...makeup,
    ...coloring,
    ...cut,
    allowAllMakeup: makeup.allowAllMakeup,
    allowedMakeupCategoryIds: makeup.allowedMakeupCategoryIds,
  };
}

export function isMakeupCategoryAllowed(categoryId, flags) {
  if (!categoryId || categoryId === 'presets') return true;
  if (!flags || flags.allowAllMakeup) return true;
  return flags.allowedMakeupCategoryIds?.has(categoryId) ?? false;
}

export function filterAllowedMakeupCategories(categoryIds, flags) {
  if (!Array.isArray(categoryIds)) return [];
  if (!flags || flags.allowAllMakeup) return categoryIds;
  return categoryIds.filter((categoryId) =>
    isMakeupCategoryAllowed(categoryId, flags),
  );
}
